import { useState } from 'react';
import axiosClient from '../utils/axiosClient';

const useSpinReward = () => {
	const [isLoading, setIsLoading] = useState(false);
	const spinCampaignId = process.env.REACT_APP_SPIN_EVENT_CAMPAIGN_ID_MY;

	const spinReward = async () => {
		try {
			setIsLoading(true);
			const reward = await axiosClient
				.post(
					'/game/start',
					{ campaignId: spinCampaignId },
					{ headers: { 'x-version': '~2' } }
				)
				.then((res) => res?.data?.data?.rewards[0])
				.finally(() => setIsLoading(false));

			return reward;
		} catch (error) {
			console.error(error);
		}
	};

	return { spinReward, isLoading };
};

export default useSpinReward;
